import { render } from "./TelBox.vue?vue&type=template&id=7e235afb&scoped=true"
import script from "./TelBox.vue?vue&type=script&lang=js"
export * from "./TelBox.vue?vue&type=script&lang=js"

import "./TelBox.vue?vue&type=style&index=0&id=7e235afb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e235afb"]])

export default __exports__